import React from 'react'
import { bool, node, object, string } from 'prop-types'

// Import Components
import { HeaderBanner } from '../HeaderBanner'
import { Footer } from '../Footer'
import { PageWrapper } from './PageWrapper'
import { AdvertisingDisclosure } from '../AdvertisingDisclosure'

Layout.propTypes = {
	boxSizing: string,
	children: node.isRequired,
	inverseLinkColors: bool,
	meta: object,
}

/**
 * This is the Layout Component
 * Wrap any page in this "template" to display the global header and footer
 * this will also give any page access to Theming and the UserProvider context component
 */
export function Layout({
	boxSizing = 'border-box',
	children,
	inverseLinkColors = false,
	isOverlappingHero = false,
	meta = {},
	hasAdDisclosure = false,
}) {
	return (
		<PageWrapper className={inverseLinkColors && 'inverse'} boxSizing={boxSizing} meta={meta}>
			{hasAdDisclosure && <AdvertisingDisclosure />}
			<HeaderBanner isOverlappingHero={isOverlappingHero} />
			{children}
			<Footer />
		</PageWrapper>
	)
}
